import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { NotificationTileComponent } from './notification-tile/notification-tile.component';
import { BadgeModule } from 'primeng/badge';
import { StocksService } from '../stocks.service';
import { AsyncPipe } from '@angular/common';

import { OverlayBadgeModule } from 'primeng/overlaybadge';
@Component({
  selector: 'app-notification-manager',
  templateUrl: './notification-manager.component.html',
  styleUrl: './notification-manager.component.scss',
  imports: [
    ButtonModule,
    OverlayPanelModule,
    NotificationTileComponent,
    BadgeModule,
    AsyncPipe,
    OverlayBadgeModule,
  ],
})
export class NotificationManagerComponent {
  stocksService = inject(StocksService);
  notifications$ = this.stocksService.getNotifications();
}
